import React from 'react';
import { number, string } from 'prop-types';
import { Tooltip } from 'ps-design';

class EllipsisText extends React.Component {
  static propTypes = {
    maxChar: number,
    text: string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { maxChar, text } = this.props;

    return (
      <React.Fragment>
        {text?.length >= maxChar ? (
          <Tooltip display="underline" hoverText={text} id={text} position="bottom" tooltipText={text} />
        ) : (
          text
        )}
      </React.Fragment>
    );
  }
}

export default EllipsisText;
